import { useDispatch, useSelector } from "react-redux";
import { State } from "../../../store";
import { useEffect, useState } from "react";
import { WebUser } from "../../../models/WebUser";
import useApiRequest from "../../../utils/hook/useApiRequest";
import {
  CREATE_NEW_BILL,
  EXERCISE_SAVE_RESERVATION,
  REGISTER_WEBUSER,
  SAVE_CUSTOMER,
  SAVE_DEPOSIT_DEFINITION
} from "../../../api/apiRoutes";
import { clearBasket } from "../../../store/basket/basketActions";
import { ACCOUNT_DEFINITION, FINALIZE_SUCCESS } from "../../../Routing/routes";
import { useHistory } from "react-router";
import getId from "../../../utils/getId";
import { setErrors } from "../../../store/alerts/alertsActions";
import { useForm } from "react-hook-form";
import getInputError from "../../../messages/inputsValidation";
import { format } from "date-fns";

export default function useFinalizePage(isInvoice: boolean, accDepositDefIds?: string) {
  const history = useHistory();
  const { isLoggedIn, webUser } = useSelector((state: State) => state.auth);
  const [loading, setLoading] = useState(false);
  const { basket, exerciseSelect } = useSelector((state: State) => state.basket);
  const getBasketTotal = () => basket.reduce((acc: number, item) => acc + item.quantity * item.assort.listPrice, 0);
  const [check, setCheck] = useState(false);
  const { post } = useApiRequest();
  const dispatch = useDispatch();
  const { register, errors, watch, setValue, reset } = useForm<any>({
    defaultValues: isLoggedIn ? webUser : ({} as WebUser),
    mode: "onBlur"
  });
  const account = watch();

  const viewError = (error: string) => {
    dispatch(setErrors([error]));
  };

  const validateFinalize = () => {
    if (!isLoggedIn) {
      if (account.firstName === "" || account.lastName === "" || account.email === "" || account.phone === "") {
        viewError("Uzupełnij wymagane pola");
        return true;
      }
      if (errors.email) {
        dispatch(setErrors([getInputError(errors, "email")]));
        return true;
      }
      if (errors.phone) {
        dispatch(setErrors([getInputError(errors, "phone")]));
        return true;
      }
    }

    if (!check) {
      viewError("Zaakceptuj regulamin, aby przejść dalej");
      return true;
    }

    return false;
  };

  const pay = async () => {
    if (validateFinalize()) {
      return;
    }
    setLoading(true);
    if (isLoggedIn) {
      if (accDepositDefIds) {
        saveDepostDefinition(webUser);
      } else {
        saveTransaction(webUser);
      }
    } else {
      const { result, isError } = await post(REGISTER_WEBUSER, account);
      if (!isError) {
        if (result) {
          if (accDepositDefIds) {
            saveDepostDefinition(result);
          } else {
            saveTransaction(result);
          }
        } else {
          setLoading(false);
          viewError("Bład zapisu konta klienta");
        }
      } else {
        setLoading(false);
      }
    }
  };

  // const savePurchaser = async () => {
  //   const purchaser = {
  //     logo: "",
  //     name: account.companyName,
  //     address: "",
  //     postName: account.zipCode,
  //     countryCode: "",
  //     vatId: account.NIP,
  //     regon: "",
  //     pesel: "",
  //     identityCard: "",
  //     affirmation: "",
  //     affirmationDate: format(new Date(), "yyyy-MM-dd"),
  //     phone: account.phone,
  //     fax: "",
  //     representative: "",
  //     description: "",
  //     discount: 0,
  //     termOfPayment: 0,
  //     isClient: false,
  //     isFreighter: false,
  //     isSupplier: false,
  //     printConfirmation: false,
  //     lastName: account.lastName,
  //     firstName: account.firstName,
  //     middleName: "",
  //     cellularPhone: "",
  //     isPerson: false,
  //     payId: "A",
  //     isPublicEntity: false,
  //     isVatPayer: false,
  //     isExcisePayer: false,
  //     isRoadTaxPayer: false,
  //     countryId: 616,
  //     email: account.email,
  //     displayOrder: 0,
  //     allowMailing: false,
  //     displayVisible: false,
  //     createdByInternet: false,
  //     sex: "A",
  //     accountsLimit: 0,
  //     birthDate: format(new Date(), "yyyy-MM-dd"),
  //     street: account.street,
  //     locality: account.city,
  //     houseNumber: account.houseNumber,
  //     flatNumber: account.flatNumber
  //   };
  //
  //   const { result, isError } = await post(SAVE_CUSTOMER, purchaser);
  //   if (!isError) {
  //     return result;
  //   }
  //
  //   return null;
  // };

  const saveDepostDefinition = async (webUser: WebUser) => {
    const object = {
      payId: "@",
      accountIds: [getId(webUser)],
      definitionIds: accDepositDefIds,
      internet: true
    };
    const { result, isError } = await post(SAVE_DEPOSIT_DEFINITION, object);
    if (!isError) {
      dispatch(clearBasket());
      setLoading(false);
      if (result.payUUrl) {
        window.location.href = result.payUUrl;
      } else {
        history.push(`${FINALIZE_SUCCESS}?redirectUrl=${ACCOUNT_DEFINITION}`);
      }
    } else {
      setLoading(false);
    }
  };

  const saveTransaction = async (webUser: WebUser) => {
    const ticketBillHolder = {
      accountPOJO: null,
      purchaser: null,
      webUserIds: {
        objectId: webUser.objectId,
        objectDb: webUser.objectDb
      },
      payType: "@",
      documentType: "IR",
      ipAddress: "",
      lines: basket,
      mailToSend: webUser.email,
      createInvoice: isInvoice,
      recipient: null,
      dontStartPayment: false
    };

    if (isInvoice) {
      const customer = {
        logo: "",
        name: account.companyName,
        address: "",
        postName: account.zipCode,
        countryCode: "",
        vatId: account.NIP,
        regon: "",
        pesel: "",
        identityCard: "",
        affirmation: "",
        affirmationDate: format(new Date(), "yyyy-MM-dd"),
        phone: account.phone,
        fax: "",
        representative: "",
        description: "",
        discount: 0,
        termOfPayment: 0,
        isClient: false,
        isFreighter: false,
        isSupplier: false,
        printConfirmation: false,
        lastName: account.lastName,
        firstName: account.firstName,
        middleName: "",
        cellularPhone: "",
        isPerson: false,
        payId: "A",
        isPublicEntity: false,
        isVatPayer: false,
        isExcisePayer: false,
        isRoadTaxPayer: false,
        countryId: 616,
        email: account.email,
        displayOrder: 0,
        allowMailing: false,
        displayVisible: false,
        createdByInternet: false,
        sex: "A",
        accountsLimit: 0,
        birthDate: format(new Date(), "yyyy-MM-dd"),
        street: account.street,
        locality: account.city,
        houseNumber: account.houseNumber,
        flatNumber: account.flatNumber
      };

      const { result, isError } = await post(SAVE_CUSTOMER, customer);
      if (!isError) {
        createBill({ ...ticketBillHolder, purchaser: result });
      }
    } else {
      createBill(ticketBillHolder);
    }
  };

  const createBill = async (ticketBillHolder: any) => {
    const { result, isError } = await post(CREATE_NEW_BILL, ticketBillHolder);
    if (!isError) {
      dispatch(clearBasket());
      setLoading(false);
      if (result.payUUrl) {
        window.location.href = result.payUUrl;
      } else {
        history.push(FINALIZE_SUCCESS);
      }
    } else {
      setLoading(false);
    }
  };

  const reservation = async () => {
    if (validateFinalize()) {
      return;
    }
    setLoading(true);
    if (isLoggedIn) {
      saveReservation(webUser);
    } else {
      const { result, isError } = await post(REGISTER_WEBUSER, account);
      if (!isError) {
        if (result) {
          saveReservation(result);
        } else {
          setLoading(false);
          viewError("Bład zapisu konta klienta");
        }
      } else {
        setLoading(false);
      }
    }
  };

  const saveReservation = async (webUser: WebUser) => {
    const { isError } = await post(EXERCISE_SAVE_RESERVATION, {
      webUserIds: getId(webUser),
      exerciseList: exerciseSelect.map(item => getId(item))
    });

    setLoading(false);
    if (!isError) {
      dispatch(clearBasket());
      history.push(FINALIZE_SUCCESS);
    }
  };

  useEffect(() => {
    if (isLoggedIn) {
      setValue("firstName", webUser.firstName);
      setValue("lastName", webUser.lastName);
      setValue("email", webUser.email);
      setValue("phone", webUser.phone);
    } else {
      reset();
    }
    // eslint-disable-next-line
  }, [isLoggedIn]);

  return {
    loading,
    getBasketTotal,
    account,
    // setAccount,
    check,
    setCheck,
    pay,
    reservation,
    userForm: {
      register,
      errors
    }
  };
}
